import React, { useState, useEffect, useContext, useCallback, useMemo } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import Page from '../../../../layout/Page/Page';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import { demoPages } from '../../../../menu';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Button from '../../../../components/bootstrap/Button';
import ModalRegisterPrinters from '../../../../components/modals/Printers/ModalRegister';
import { DefaultContext } from '../../../../contexts/default';
import PrinterDB from '../../../../database/wrappers/printer';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import showNotification from '../../../../components/extras/showNotification';
import notificationBody from '../../../../helpers/utils/functions/notificationBody';
import { orderBy } from 'firebase/firestore';
import SelectStore from '../../../../components/MyCustom/SelectStore';
import useDarkMode from '../../../../hooks/useDarkMode';
import ModalTestPrinters from '../../../../components/modals/Printers/ModalTestPrinter';
import MonitorsDB from '../../../../database/wrappers/monitor';
import ModalRegisterMonitors from '../../../../components/modals/Monitors/ModalRegister';
import StoreMonitorOrdersDB from '../../../../database/wrappers/storeMonitorOrders';

const Printers = () => {
    const { darkModeStatus } = useDarkMode();

    const { establishment, store, onShowAlert, onShowQuestion } = useContext(DefaultContext);

    const [openModalTest, setOpenModalTest] = useState(false);
    const [openModalRegister, setOpenModalRegister] = useState(false);
    const [monitors, setMonitors] = useState([]);
    const [monitorSelected, setMonitorSelected] = useState(null);

    useEffect(() => {
        if (!establishment || !store) return;
        const onSubscribe = new MonitorsDB(establishment.id, store.id).on(setMonitors);
        return onSubscribe;
    }, [establishment, store])

    const handleOpenModalRegister = useCallback(() => {
        setMonitorSelected(null)
        setOpenModalRegister(true);
    }, [])

    const handleCloseModalRegister = useCallback(() => {
        setOpenModalRegister(false);
    }, [])

    const handleOpenModalEdit = useCallback((item) => {
        setMonitorSelected(item);
        setOpenModalRegister(true)
    }, [])

    const handleOpenModalDelete = useCallback((id) => {
        onShowQuestion({
            title: 'Exclusão de monitor',
            message: 'Você está excluindo uma monitor. Está ação é irreversível. Deseja continuar?',
            onConfirm: () => {
                new MonitorsDB(establishment.id, store.id)
                    .delete(id)
                    .then(res => showNotification('', notificationBody('Registro deletado com sucesso'), 'success'))
                    .catch(err => showNotification('', notificationBody('Falhou ao deletar o registro'), 'danger'))
            }
        })
    }, [])



    const handleOpenModalClear = useCallback((row) => {
        onShowQuestion({
            title: 'Limpar dados',
            message: 'Essa ação irá remover permanentemente os dados de PEDIDOS deste monitor. Tem certeza de que deseja continuar?',            
            onConfirm: () => {
               new StoreMonitorOrdersDB(establishment.id, store.id)
                .deleteByMonitorId(row.id)
                .then(res => showNotification('', notificationBody('Registros deletados com sucesso'), 'success'))
                .catch(err => showNotification('', notificationBody('Falhou ao deletar os registros'), 'danger'))
            }
        })
    }, [establishment, store])


    const handleChangeStatus = useCallback((id, active) => {
        new MonitorsDB(establishment.id, store.id)
            .update(id, {
                active: !active
            })
            .catch(error => onShowAlert({
                title: 'ERRO!',
                msm: 'Não foi possível atualizar o status do produto',
                icon: 'Error',
                color: 'danger'
            }))
    }, [establishment, store])

    const columns = useMemo(() => ([
        {
            label: 'Nome',
            field: 'name',
        },
        {
            label: 'QTD. Usuários',
            field: 'users',
            format: row => row.users?.length,
            formatExport: value => value?.length
        },
        {
            label: 'Key',
            field: 'key'
        },
        {
            label: 'Status',
            field: 'active',
            format: row => (
                <Button
                    isLink
                    color={row.active ? 'success' : 'danger'}
                    icon='Circle'
                    onClick={() => handleChangeStatus(row.id, row.active)}
                    className='text-nowrap'>
                    {row.active ? 'Ativo' : 'Inativo'}
                </Button>
            ),
            formatExport: value => value ? 'Ativo' : 'Inativo'
        },
        {
            label: 'Dados',
            field: 'actions',
            format: row => (
                <div className='d-flex justify-content-between'>
                   <Button
                        className='me-2'
                        color="warning"
                        icon="Eraser"
                        shadow="sm"
                        hoverShadow="sm"
                        size="sm"
                        onClick={() => handleOpenModalClear(row)}
            >
                Limpar dados
                </Button>    
                </div>
            ),
            noExport: true,
        },
        
        {
            label: 'Ações',
            field: 'actions',
            format: row => (
                <div className='w-25 d-flex justify-content-between'>
                    <Button
                        color={darkModeStatus ? 'light' : 'dark'}
                        icon="edit"
                        shadow="sm"
                        hoverShadow="sm"
                        size="sm"
                        onClick={() => handleOpenModalEdit(row)}
                    />
                    <Button
                        className='ms-2'
                        color="danger"
                        icon="Trash"
                        shadow="sm"
                        hoverShadow="sm"
                        size="sm"
                        onClick={() => handleOpenModalDelete(row.id)}
                    />

    
                </div>
            ),
            noExport: true,
        },
    ]), [handleChangeStatus, handleOpenModalEdit, handleOpenModalDelete])

    return (
        <>
            <PageWrapper title={demoPages.store.subMenu.monitors.text}>
                <SubHeader>
                    <SubHeaderLeft>
                        <Breadcrumb
                            list={[
                                { title: 'Loja', to: '/store/monitors' },
                                {
                                    title: 'Monitores',
                                    to: '/store/monitors',
                                },
                            ]}
                        />
                    </SubHeaderLeft>
                    <SubHeaderRight>
                        <Button
                            color='primary'
                            icon='plus'
                            shadow="sm"
                            hoverShadow="sm"
                            onClick={handleOpenModalRegister}
                        >
                            Cadastrar
                        </Button>
                    </SubHeaderRight>
                </SubHeader>
                <Page container="flui">
                    <Card>
                        <CardBody className='table-responsive'>
                            <div className='row d-flex align-items-center mt-4 mx-1' >
                                <SelectEstablishment />
                                <SelectStore />
                            </div>

                            <TableCustom 
                                columns={columns} 
                                rows={monitors} 
                                fileName={'Monitores'} 
                            />
                        </CardBody>
                    </Card>
                </Page>
            </PageWrapper>

            <ModalRegisterMonitors
                open={openModalRegister}
                setIsOpen={setOpenModalRegister}
                setIsClose={handleCloseModalRegister}
                monitorSelected={monitorSelected}
            />


        </>
    );
};

export default Printers;
